module.exports = __webpack_public_path__ + "media/images/emoticons/noodle-e7b3bbe41519120cdd5a6301628ea0ab.gif";